import script from "./TenantManagement.vue?vue&type=script&lang=ts&setup=true"
export * from "./TenantManagement.vue?vue&type=script&lang=ts&setup=true"

import "./TenantManagement.vue?vue&type=style&index=0&id=02d17b57&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02d17b57"]])

export default __exports__